import {UserLite} from '../../../../common/types/user'
import {formatISO, parseISO} from '../../../../common/utils/dateUtils'

interface SignupDataPoint {
  date: string
  allUsers: number
  withPayment: number
  withRentals: number
  paymentShare: number
  rentalShare: number
}

export const generateUserSignupData = (users: UserLite[]): SignupDataPoint[] => {
  const grouped = new Map<string, SignupDataPoint>()

  users.forEach((user) => {
    if (!user.accountCreated) return
    const date = formatISO(parseISO(user.accountCreated), {
      representation: 'date',
    })

    if (!grouped.has(date)) {
      grouped.set(date, {
        date,
        allUsers: 0,
        withPayment: 0,
        withRentals: 0,
        paymentShare: 0,
        rentalShare: 0,
      })
    }

    const current = grouped.get(date)!
    current.allUsers += 1
    if (user.paymentInformation) current.withPayment += 1
    if (user.numberOfRentals > 0) current.withRentals += 1
  })

  return Array.from(grouped.values())
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((point) => ({
      ...point,
      paymentShare: point.allUsers > 0 ? Math.round((point.withPayment / point.allUsers) * 100) : 0,
      rentalShare: point.withPayment > 0 ? Math.round((point.withRentals / point.withPayment) * 100) : 0,
    }))
}
